import { render, staticRenderFns } from "./ViewSchedule.vue?vue&type=template&id=56148ada&scoped=true"
import script from "./ViewSchedule.vue?vue&type=script&lang=js"
export * from "./ViewSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56148ada",
  null
  
)

export default component.exports